var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDangerous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 21.5L0.5 15.375V6.625L6.625 0.5H15.375L21.5 6.625V15.375L15.375 21.5H6.625ZM7.61667 19.1667H14.3833L19.1667 14.3833V7.61667L14.3833 2.83333H7.61667L2.83333 7.61667V14.3833L7.61667 19.1667ZM7.675 15.9583L11 12.6333L14.325 15.9583L15.9583 14.325L12.6333 11L15.9583 7.675L14.325 6.04167L11 9.36667L7.675 6.04167L6.04167 7.675L9.36667 11L6.04167 14.325L7.675 15.9583Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDangerous);
export default __webpack_public_path__ + "static/media/icon_dangerous.400a1721f0ef600ab2b6266e459b7a42.svg";
export { ForwardRef as ReactComponent };